import React from "react";
import OurMission from "../../components/OurMission";

function ourMissionPage(){
    return(
        <div>
        <OurMission />
        </div>
    );
}

export default ourMissionPage;